"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DirectDebitMandateInfoPagePlain = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var queryString = require("query-string");
var core_1 = require("@athena-portal/core");
var Types_1 = require("../../Types");
var MandateHistoryTable_1 = require("./MandateHistoryTable");
var components_1 = require("@athena-portal/components");
var SupportPortalTemplates_1 = require("../../SupportPortalTemplates");
var operators_1 = require("rxjs/operators");
var MandateStatusTable_1 = require("./MandateStatusTable");
var DirectDebitMandateInfoPagePlain = /** @class */ (function (_super) {
    __extends(DirectDebitMandateInfoPagePlain, _super);
    function DirectDebitMandateInfoPagePlain(props) {
        var _this = _super.call(this, props) || this;
        _this.templates = new SupportPortalTemplates_1.SupportPortalTemplates();
        _this.incrementLoadingQueueSize = function (callback) {
            _this.setState(function (prevState) { return ({
                loadingQueueSize: prevState.loadingQueueSize + 1
            }); }, callback);
        };
        _this.decrementLoadingQueueSize = function (callback) {
            if (_this.state.loadingQueueSize === 0) {
                return;
            }
            _this.setState(function (prevState) { return ({
                loadingQueueSize: prevState.loadingQueueSize - 1
            }); }, callback);
        };
        _this.loading = function () {
            return _this.state.loadingQueueSize !== 0;
        };
        _this.state = {
            loadingQueueSize: 0
        };
        return _this;
    }
    DirectDebitMandateInfoPagePlain.prototype.componentDidMount = function () {
        var _this = this;
        this.incrementLoadingQueueSize(function () {
            _this.setState({ policyNumber: queryString.parse(_this.props.location.search).policy });
            _this.decrementLoadingQueueSize();
        });
        this.incrementLoadingQueueSize(function () {
            _this.supportPortalService
                .getParty(_this.props.params.id)
                .pipe((0, operators_1.finalize)(_this.decrementLoadingQueueSize))
                .subscribe(function (party) {
                _this.setState({ party: party });
            });
        });
        this.incrementLoadingQueueSize(function () {
            _this.supportPortalService
                .getMandatesByPolicyNumber(_this.props.params.number)
                .pipe((0, operators_1.finalize)(_this.decrementLoadingQueueSize))
                .subscribe(function (mandates) {
                _this.setState({ mandates: mandates });
            });
        });
    };
    DirectDebitMandateInfoPagePlain.prototype.render = function () {
        var _a, _b, _c;
        var firstName = (_a = this.state.party) === null || _a === void 0 ? void 0 : _a.firstName;
        var lastname = (_b = this.state.party) === null || _b === void 0 ? void 0 : _b.lastName;
        document.title = "".concat(firstName, " ").concat(lastname, " direct debit mandate");
        var latestMandate = (_c = this.state.mandates) === null || _c === void 0 ? void 0 : _c.sort(function (b, a) { return a.id - b.id; })[0];
        if (this.templates.userHasRole(["Administrator", "Claims_Handler", "Fraud", "CSR_Lead", "CSR", "Support", "Read_Only"])) {
            return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(components_1.Overlay, { show: this.loading() }), this.templates.renderHeader(), this.templates.renderBackLink("Customer page", true, "/customers/".concat(this.props.params.id)), latestMandate && (0, jsx_runtime_1.jsx)(MandateStatusTable_1.default, { mandate: latestMandate, customerReferenceNumber: this.props.params.id, loading: this.loading() }), this.state.mandates && (0, jsx_runtime_1.jsx)(MandateHistoryTable_1.default, { mandates: this.state.mandates, loading: this.loading(), customerReferenceNumber: this.props.params.id })] }));
        }
        else {
            return this.templates.renderErrorPage();
        }
    };
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.SupportPortalService),
        __metadata("design:type", Object)
    ], DirectDebitMandateInfoPagePlain.prototype, "supportPortalService", void 0);
    DirectDebitMandateInfoPagePlain = __decorate([
        components_1.authorize,
        __metadata("design:paramtypes", [Object])
    ], DirectDebitMandateInfoPagePlain);
    return DirectDebitMandateInfoPagePlain;
}(React.Component));
exports.DirectDebitMandateInfoPagePlain = DirectDebitMandateInfoPagePlain;
exports.default = (0, components_1.withRouter)(DirectDebitMandateInfoPagePlain);
//# sourceMappingURL=DirectDebitMandateInfoPage.js.map